module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('shopmng.crumbs.L1')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group panel-select-group__justify"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.title.baseInfo')))])])]), _vm._v(" "), (!_vm.role.isCashier) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "info_wrapper"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.panel.loginAccount')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.shopName')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.shopname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.address')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.address))])]), _vm._v(" "), (_vm.role.country !== 'ID') ? _c('div', [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.mobile')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.telephone || _vm.$t('common.none')))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.cardHolder')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.bankuser))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.bankAccount')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.bankaccount) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.bankName')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.headbankname))])]), _vm._v(" "), _c('div', {
    staticClass: "info upload-logos"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("Logo")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_c('div', {
    staticClass: "upload-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.uploadInfo.url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "limited——size"
  }, [_vm._v("* " + _vm._s(_vm.$t('uploadMessage.fileSize')))]), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.uploadLoading),
      expression: "uploadLoading"
    }],
    staticClass: "upload-demo",
    attrs: {
      "on-progress": _vm.startAvatarUpload,
      "action": _vm.uploadInterfaceFile,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "data": {
        category: 1,
        source: 1,
        tag: 'otherphoto',
        enuserid: 'EPeRaNEt',
        format: 'cors'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('uploadMessage.uploadNow')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.bankname))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-btn-group__wrapper"
  }, [_c('div', {
    staticClass: "panel-btn__download panel-btn__download_record",
    on: {
      "click": function($event) {
        return _vm.changePass(_vm.shop.mobile)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.panel.table.editPwd')))])])])]) : _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "info_wrapper"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.status')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.status ? _vm.$t('cashMng.mng.status3') : _vm.$t('cashMng.mng.status4')))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.name')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.opname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.mobile')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.shop')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.shopname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.user')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info next-bottom",
    style: (_vm.lang === 'ja' ? {
      'margin-bottom': '10px'
    } : '')
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.number')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.opuid))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }), _vm._v(" "), _c('div', {
    staticClass: "gray-explain"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.tip1')))])]), _vm._v(" "), (!_vm.role.haiwai) ? _c('div', {
    staticClass: "info next-bottom"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("退款权限")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.refund ? '有权限' : '无权限'))])]) : _vm._e(), _vm._v(" "), (!_vm.role.haiwai) ? _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }), _vm._v(" "), _c('div', {
    staticClass: "gray-explain"
  }, [_vm._v("* 目前收银员仅支持查看活动信息，不支持对红包、集点、储值活动、特卖、店铺公告、会员特权的增删改")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-btn-group__wrapper"
  }, [(!_vm.role.haiwai) ? _c('a', {
    attrs: {
      "href": _vm.downHref,
      "download": ""
    }
  }, [_vm._m(0)]) : _vm._e()])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('shopmng.dialog.editPwd'),
      "visible": _vm.showChangePass,
      "custom-class": "mydialog",
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showChangePass = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('shopmng.dialog.loginAccount')
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.userName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('shopmng.dialog.inputNewPwd'),
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "auto-complete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('shopmng.dialog.msg.m1')
    },
    model: {
      value: (_vm.form.pass),
      callback: function($$v) {
        _vm.$set(_vm.form, "pass", $$v)
      },
      expression: "form.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('shopmng.dialog.confirmNewPwd'),
      "prop": "repass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "auto-complete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('shopmng.dialog.msg.m2')
    },
    model: {
      value: (_vm.form.repass),
      callback: function($$v) {
        _vm.$set(_vm.form, "repass", $$v)
      },
      expression: "form.repass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.showChangePass = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('shopmng.dialog.cancel')))]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.submit
    }
  }, [(_vm.iconShow) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('shopmng.dialog.ok')))])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill"
  }, [_c('i', {
    staticClass: "icon-download"
  }), _vm._v(" "), _c('span', [_vm._v("下载收款二维码")])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-9b7aea70"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/singlemanage/singlemanage.vue
// module id = 929
// module chunks = 0